const data = [ 
    {
      widgetName: "Site map",
      items: [
        {
          title: "Home",
          url: "/",
        },
        {
          title: "About",
          url: "#about",
        },
        {
          title: "Features",
          url: "#features",
        },
        {
          title: "FAQ",
          url: "#faq",
        },
        {
          title: "Articles",
          url: "#",
        }
      ],
    },
    {
      widgetName: "Quick Links",
      items: [
        {
          title: "Whitepaper",
          url: "#",
        },
        {
          title: "Terms Conditions",
          url: "#",
        },
        {
          title: "Privacy Policy",
          url: "#",
        },
      ],
    },

]

export default data;
